import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=bb81d3a6&"
import script from "./TreeItem.vue?vue&type=script&lang=js&"
export * from "./TreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports